import { create } from "zustand";

import { api, type RegisterPayload, type UserMe } from "@/api/client";

interface AuthState {
  user: UserMe | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  login: (email: string, password: string) => Promise<void>;
  register: (payload: RegisterPayload) => Promise<UserMe>;
  logout: () => Promise<void>;
  loadMe: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isAuthenticated: !!localStorage.getItem("ca_access_token"),
  isLoading: false,

  login: async (email, password) => {
    set({ isLoading: true });
    try {
      const tokens = await api.login(email, password);
      localStorage.setItem("ca_access_token", tokens.access_token);
      localStorage.setItem("ca_refresh_token", tokens.refresh_token);
      const user = await api.me();
      set({ user, isAuthenticated: true });
    } finally {
      set({ isLoading: false });
    }
  },

  register: async (payload) => {
    // Self-Service: NICHT direkt einloggen — der User ist 'pending' und
    // sieht nach der Registrierung die Danke-Anzeige. Beim ersten Login
    // landet er via RequireAuth auf /activate (Code-Einlösung = Kauf =
    // Freischaltung; alternativ Admin-Approve wie bisher).
    return await api.register(payload);
  },

  logout: async () => {
    const refresh = localStorage.getItem("ca_refresh_token");
    if (refresh) {
      try {
        await api.logout(refresh);
      } catch {
        // ignore
      }
    }
    localStorage.removeItem("ca_access_token");
    localStorage.removeItem("ca_refresh_token");
    set({ user: null, isAuthenticated: false });
  },

  loadMe: async () => {
    if (!localStorage.getItem("ca_access_token")) return;
    try {
      const user = await api.me();
      set({ user, isAuthenticated: true });
    } catch {
      localStorage.removeItem("ca_access_token");
      localStorage.removeItem("ca_refresh_token");
      set({ user: null, isAuthenticated: false });
    }
  },
}));
